module.exports = __webpack_public_path__ + "static/1.2.C.1 Randare 1-2f6a591a9d975ec2ba1fefe9a6647000.jpg";